export function maskCurrency(value: number, locale = 'pt-BR', currency = 'BRL') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(value);
}

export const maskMoney = (value: string): string => {
  if (!value) return '';

  if (typeof value === 'number') {
    return maskCurrency(parseFloat(value));
  }

  const onlyDigits = value
    .split('')
    .filter((s) => /\d/.test(s))
    .join('')
    .padStart(3, '0');

  const digitsFloat = onlyDigits.slice(0, -2) + '.' + onlyDigits.slice(-2);

  value = maskCurrency(parseFloat(digitsFloat));

  return value;
};
